const BASE_URL = "https://api.zulluai.com/api";
// const BASE_URL = "http://localhost:4500/api";

const buildDeductCreditsPayload = (identifier, deductAmount) => {
  const key = identifier.includes("@") ? "email" : "phoneNumber";
  return { [key]: identifier, deductAmount };
};

export const ApiService = {
  // 1. GET USER INFO
  // Works for both Phone (Option A) and Google users
  getUserInfo: async (identifier) => {
    // If identifier contains '@', treat as email, else treat as phone
    const queryParam = identifier.includes("@")
      ? `email=${identifier}`
      : `phoneNumber=${identifier}`;
    const response = await fetch(`${BASE_URL}/get-personal-info?${queryParam}`);
    return await response.json();
  },

  // 2. GOOGLE LOGIN
  googleLogin: async (idToken) => {
    const response = await fetch(`${BASE_URL}/google-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idToken }),
    });
    return await response.json();
  },

  // 3. START VIDEO GENERATION
  // Using FormData: No headers needed, browser sets boundary automatically
  startGeneration: async (formData) => {
    const response = await fetch(`${BASE_URL}/video/generate`, {
      method: "POST",
      body: formData,
    });
    return await response.json();
  },

  startProviderVideoGeneration: async (provider, formData) => {
    const endpointMap = {
      grok: "video",
      luma: "luma-video",
      wan: "wan-video",
      a2eWan: "a2e-wan-video",
    };
    const endpoint = endpointMap[provider] || endpointMap.grok;
    const response = await fetch(`${BASE_URL}/${endpoint}/generate`, {
      method: "POST",
      body: formData,
    });
    return await response.json();
  },

  // 4. CHECK VIDEO STATUS (POLLING)
  // Renamed/Added to match your VideoResult.js usage
  getVideoStatus: async (jobId) => {
    const response = await fetch(`${BASE_URL}/video/status/${jobId}`);
    return await response.json();
  },

  getProviderVideoStatus: async (provider, jobId) => {
    const endpointMap = {
      grok: "video",
      luma: "luma-video",
      wan: "wan-video",
      a2eWan: "a2e-wan-video",
    };
    const endpoint = endpointMap[provider] || endpointMap.grok;
    const response = await fetch(`${BASE_URL}/${endpoint}/status/${jobId}`);
    return await response.json();
  },

  // 5. USER VIDEO HISTORY
  getUserHistory: async (identifier) => {
    const response = await fetch(`${BASE_URL}/video/history/${identifier}`);
    return await response.json();
  },

  // 5b. USER IMAGE HISTORY
  getUserImageHistory: async (identifier) => {
    const response = await fetch(`${BASE_URL}/grok/generated-images/history/${identifier}`);
    return await response.json();
  },

  // 6. DEDUCT CREDITS (Updated to use fetch)
  deductCredits: async (payload) => {
    const response = await fetch(`${BASE_URL}/deduct-credits`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return await response.json();
  },

  deductCreditsForIdentifier: async (identifier, deductAmount) => {
    const response = await fetch(`${BASE_URL}/deduct-credits`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(buildDeductCreditsPayload(identifier, deductAmount)),
    });
    return await response.json();
  },

  async generateImage(payload) {
    try {
      const response = await fetch(`${BASE_URL}/grok/generate-image`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // If you use token-based auth, include it here:
          // 'Authorization': `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || "Failed to generate image");
      }
  
      return data;
    } catch (error) {
      console.error("ApiService generateImage Error:", error);
      throw error;
    }
  }
};
